const storageKey = (key) => `override:${ key }`;

/* Testing override read from the URL query string, persisted in sessionStorage so it survives client-side navigation until the tab closes. An empty query value (e.g. ?grade=) clears a previously stored override, ?clear clears all of them */
const getQueryOverride = (key) => {
    const params = new URLSearchParams(window.location.search);

    if(params.has("clear")) {
        Object.keys(sessionStorage)
            .filter(storedKey => storedKey.startsWith(storageKey("")))
            .forEach(storedKey => sessionStorage.removeItem(storedKey));
    }

    const value = params.get(key);

    if(value === "") {
        sessionStorage.removeItem(storageKey(key));
        return null;
    }
    if(value !== null) {
        sessionStorage.setItem(storageKey(key), value);
        return value;
    }

    return sessionStorage.getItem(storageKey(key));
};

/* Comma separated variant of getQueryOverride, e.g. ?los=tax,deals */
export const getQueryOverrideList = (key) => {
    const value = getQueryOverride(key);
    return value === null ? null : value.split(",").map(item => item.trim()).filter(Boolean);
};

export default getQueryOverride;
